import { render, staticRenderFns } from "./DialogAgreement.vue?vue&type=template&id=84112af4&"
import script from "./DialogAgreement.vue?vue&type=script&lang=js&"
export * from "./DialogAgreement.vue?vue&type=script&lang=js&"
import style0 from "./DialogAgreement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports